import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import WorkOutlineIcon from '@mui/icons-material/WorkOutline'

export const RecorteProfissaoFilterPreview = () => {
    // State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeEditRecorteFormFiltros } = useRecortesExtracaoService()

    const hasProfissao = editRecorteExtracaoForm.fields.Filtros?.profissao &&
        editRecorteExtracaoForm.fields.Filtros.profissao.length > 0;

    const handleRemoveFilter = () => {
        removeEditRecorteFormFiltros({ filtro: 'profissao' });
    };

    if (!hasProfissao) {
        return null;
    }

    return (
        <Grid item container xs={6} spacing={2} mb={2}>
            <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                    <Grid item>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mr={2}
                        >
                            Profissão
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={handleRemoveFilter}
                        >
                            Remover filtro
                        </Button>
                    </Grid>
                </Grid>

                {editRecorteExtracaoForm.fields.Filtros &&
                    editRecorteExtracaoForm.fields.Filtros.profissao && (
                        <Grid item xs={12}>
                            <Stack
                                direction="row"
                                flexWrap="wrap"
                            >
                                {editRecorteExtracaoForm.fields.Filtros.profissao.map((profissao, i) => (
                                    <Chip
                                        key={i}
                                        icon={<WorkOutlineIcon />}
                                        label={`${profissao.familiacodigo} - ${profissao?.familiadescricao?.toUpperCase()}`}
                                        sx={{
                                            m: 0.5
                                        }}
                                    />
                                ))}
                            </Stack>
                        </Grid>
                    )}
            </Paper>
        </Grid>
    )
}